import React, { useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";

function QualityManual_view_offcanvas({ show, handleClose }) {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Offcanvas
        className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
        show={show}
        placement="end"
        onHide={handleClose}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="back_div" onClick={handleClose}>
              <Common_Back_Btn />
            </div>
            View Quality Manual
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Employee ID</Form.Label>
                  <Form.Control value="Empid1001" disabled />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Employee Name</Form.Label>
                  <Form.Control value="Oshin Kawale" disabled />
                </Form.Group>
              </div>

              <div className="col-md-12">
                <Form.Group className="form_group">
                  <Form.Label>Designation</Form.Label>
                  <Form.Control value="Lab In-Charge" disabled />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group file_field">
                  <Form.Label>Attached File</Form.Label>
                  <div className="image_holder">
                    <img className="img_preview" src="/assets/images/other/dummy-image.png" />
                  </div>
                  <div className="span_text_holder">
                    <div>
                      <span>Imperiality PDF.2Kb</span>
                    </div>

                    <div>
                      <span className="green_text" onClick={() => {
                            setShowModal(true);
                            handleClose();
                          }}>
                        <FontAwesomeIcon
                          icon={faEye}
                          className="me-2"
                          
                        />{" "}
                        View
                      </span>
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Certification_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalHeadingText={"View Quality Manual"}
        imgSrc={"/assets/images/cerificate/certi.png"}
        btnText={"Download"}
      />
    </>
  );
}

export default QualityManual_view_offcanvas;
